import {createApp} from 'vue';
import SearchForm from './SearchForm.vue';

if(document.getElementById('search-form-app')) {
    const app = createApp({
        components: {
            SearchForm
        }
    });
    app.mount('#search-form-app');
}